import React from 'react';

function ClockIcon({ color = '#BECDE0' }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M14.34 0H5.67C2.28 0 0 2.38 0 5.92V14.09C0 17.62 2.28 20 5.67 20H14.34C17.73 20 20 17.62 20 14.09V5.92C20 2.38 17.73 0 14.34 0Z"
        fill={color}
      />
      <path
        d="M13.5734 13.8143C13.4424 13.8143 13.3104 13.7803 13.1894 13.7093L9.26344 11.3673C9.03744 11.2313 8.89844 10.9863 8.89844 10.7223V5.67529C8.89844 5.26129 9.23444 4.92529 9.64844 4.92529C10.0624 4.92529 10.3984 5.26129 10.3984 5.67529V10.2963L13.9584 12.4193C14.3134 12.6323 14.4304 13.0923 14.2184 13.4483C14.0774 13.6833 13.8284 13.8143 13.5734 13.8143Z"
        fill={color}
      />
    </svg>
  );
}

export default ClockIcon;
